import { render, staticRenderFns } from "./StatsLibraires.vue?vue&type=template&id=8f4013d8&scoped=true&"
import script from "./StatsLibraires.vue?vue&type=script&lang=js&"
export * from "./StatsLibraires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4013d8",
  null
  
)

export default component.exports